/* eslint-disable */
const PhoneSimple = text => {
  // const re = /^(\(\d{3}\)|\d{3})-?\d{3}-?\d{4}$/;
  // return re.test(text);
  return !isNaN(parseFloat(text)) && isFinite(text);
};
/* eslint-enable */

export default PhoneSimple;
